import { isEmpty } from 'ramda';

import { getLabelMessage } from '@gef-ui/localization/messages';

export const createGuarantorCardText = (guarantors) => {
	if (isEmpty(guarantors)) {
		return getLabelMessage('guarantors:none');
	} else if (guarantors.length === 1) {
		let onlyGuarantor = {};
		[onlyGuarantor] = guarantors;
		return `${onlyGuarantor.surname} ${onlyGuarantor.firstName ? onlyGuarantor.firstName : ''}`;
	} else if (guarantors.length < 5) {
		return `${guarantors.length} - ${getLabelMessage('guarantors:moreThenOne')}`;
	} else {
		return `${guarantors.length} - ${getLabelMessage('guarantors:moreThenFive')}`;
	}
};
